import { LinearGradient } from "expo-linear-gradient";
import { Spacer, VStack } from "native-base";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";

import { useViewport } from "@/contexts/ViewportContext";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

type FormLoadingProps = {
  numberOfFields?: number;
};

const FormLoading = ({ numberOfFields = 4 }: FormLoadingProps) => {
  const { isWebMode, width: nativeWidth } = useViewport();
  const width = isWebMode ? nativeWidth / 3 : nativeWidth - 40;
  return (
    <VStack space={4} w="full">
      {Array(numberOfFields)
        .fill(null)
        .map((i, k) => (
          <VStack key={k} space={2}>
            <ShimmerPlaceholder width={width / 2} />
            <ShimmerPlaceholder width={width} height={36} />
          </VStack>
        ))}
      <Spacer />
      <ShimmerPlaceholder width={width} height={36} />
      <ShimmerPlaceholder width={width} height={36} />
    </VStack>
  );
};

export default FormLoading;
